import { Injectable, NgZone }     from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BehaviorSubject} from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import {TrackerService} from './tracker';
import {RoutesService} from './routes';
import { PlatformService } from './platform.service';

declare let window: any;

const REFRESH_RATE = 1000;

@Injectable()
export class SearchService {
  index:any;
  query:string;
  resultSubject:BehaviorSubject<Array<any>|null>;
  results:Observable<Array<any>|null>;
  interval:any;
  requestID:number;
  subscriptions:any[] = [];

  constructor(
    private routes:RoutesService,
    private tracker:TrackerService,
    private zone:NgZone,
    private platformService:PlatformService
  ) {
    window.searchService = window.lucybot.searchService = this;
    this.resultSubject = new BehaviorSubject(null);
    this.results = this.resultSubject.asObservable();
    this.startSearchInterval();

    this.subscriptions.push(this.results.subscribe(val => {
      if (!val) return;
      let params:any = {};
      params.query = this.query || null;
      this.routes.addQueryParams(params);
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  startSearchInterval() {
    if (this.interval) window.clearInterval(this.interval);
    let lastQuery = undefined;
    this.zone.runOutsideAngular(() => {
      this.interval = setInterval(() => {
        if (this.query === lastQuery) return;
        lastQuery = this.query;
        this.zone.run(() => {
          this.performSearch();
        });
      }, REFRESH_RATE);
    });
  }

  performSearch() {
    if (!this.query) return this.resultSubject.next([]);
    this.tracker.track('search', {query: this.query});
    if (window.lucybot.search) {
      window.lucybot.search(this.query, '', (err, results) => {
        if (err) throw err;
        this.resultSubject.next(results);
      })
    } else {
      if (!this.index) return setTimeout(() => this.performSearch(), 100);
      let results = this.index.search(this.query);
      this.resultSubject.next(results);
    }
  }

  setItems(items) {
    if (this.platformService.isServer || window.lucybot.search) {
      return;
    }
    this.index = null;
    this.requestID = Math.floor(Math.random() * 10000000000);
    const LunrWorker = require('!worker-loader!../lunr_worker');
    let worker = new LunrWorker;
    worker.onmessage = e => {
      let message = JSON.parse(e.data);
      if (message.requestID === this.requestID) {
        this.index = window.lunr.Index.load(message.index);
      }
      worker.terminate();
    }
    worker.postMessage({requestID: this.requestID, items});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/search.ts